module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-eofy-banner.957847d0.png";